import React from 'react';
import { Grid } from '@mui/material';
import Shell from '../../../../common/components/Shell/Shell';
import ShiftAndSchedulePresenter from './ShiftAndSchedulePresenter';
import { useTranslation } from 'react-i18next';

function ShiftAndScheduleControllerSwapShift2UI() {
  const { t, i18n } = useTranslation();
  return (
    <Shell>
      <Grid
        container
        style={{
          maxWidth: 'auto',
          marginLeft: i18n.language == 'en' ? '7.25em' : '',
        }}
      >
        <ShiftAndSchedulePresenter trans={t} i18n={i18n} />
      </Grid>
    </Shell>
  );
}
export default ShiftAndScheduleControllerSwapShift2UI;
